module.exports = __webpack_public_path__ + "static/img/智慧城市展馆.fdf3495d.png";